/* istanbul ignore file */
import React from 'react';
import { EMPLOYEE_WORKING_STATUSES } from 'domain/shared/employee';
import { EnumField, FieldProps } from 'framework/ui/field';

const EmployeeWorkingStatusField = (props: FieldProps) => {
  return <EnumField {...props} options={EMPLOYEE_WORKING_STATUSES} />;
};

export default EmployeeWorkingStatusField;
